var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000114360949 -0.0005 25 -0.0005 25 24.9995 0.000114360949 24.9995"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humana-tray-110420",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web_Uber-welcome-tray_v2b-Copy",
    transform: "translate(-33.000000, -605.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(33.000000, 605.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.000600)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2121,23.0775 C22.9691,23.3595 22.6171,23.5215 22.2441,23.5215 L2.7551,23.5215 C2.3831,23.5215 2.0301,23.3595 1.7881,23.0775 C1.5451,22.7955 1.4371,22.4225 1.4931,22.0545 L1.8111,19.9375 L23.1881,19.9375 L23.5071,22.0545 C23.5621,22.4225 23.4551,22.7955 23.2121,23.0775 L23.2121,23.0775 Z M3.4271,9.2035 C3.5221,8.5735 4.0531,8.1165 4.6901,8.1165 L6.8821,8.1165 L9.6151,8.1165 C9.6681,8.1285 18.1421,8.1165 18.1421,8.1165 L20.3101,8.1165 C20.9471,8.1165 21.4781,8.5735 21.5731,9.2035 L22.9661,18.4585 L2.0341,18.4585 L3.4271,9.2035 Z M10.5191,6.6385 L10.5191,4.2545 L14.6581,4.2405 L14.6581,6.6385 L10.5191,6.6385 Z M7.6211,2.7545 C7.6211,2.0505 8.1941,1.4775 8.8981,1.4775 L16.1261,1.4775 C16.8301,1.4775 17.4031,2.0505 17.4031,2.7545 L17.4031,6.6385 L16.1371,6.6385 L16.1371,3.4985 C16.1371,3.3025 16.0581,3.1135 15.9191,2.9745 C15.7811,2.8365 15.5931,2.7595 15.3971,2.7595 L15.3951,2.7595 L9.7771,2.7785 C9.3691,2.7795 9.0401,3.1105 9.0401,3.5175 L9.0401,6.6385 L7.6211,6.6385 L7.6211,2.7545 Z M23.0351,8.9835 C22.8301,7.6245 21.6841,6.6385 20.3101,6.6385 L18.8811,6.6385 L18.8811,2.7545 C18.8811,1.2355 17.6451,-0.0005 16.1261,-0.0005 L8.8981,-0.0005 C7.3791,-0.0005 6.1431,1.2355 6.1431,2.7545 L6.1431,6.6385 L4.6901,6.6385 C3.3161,6.6385 2.1701,7.6245 1.9651,8.9835 L0.0311,21.8345 C-0.0889,22.6285 0.1431,23.4335 0.6671,24.0425 C1.1911,24.6505 1.9521,24.9995 2.7551,24.9995 L22.2441,24.9995 C23.0471,24.9995 23.8091,24.6505 24.3331,24.0425 C24.8571,23.4335 25.0891,22.6285 24.9691,21.8345 L23.0351,8.9835 Z",
    id: "Fill-1",
    fill: "#F5426E",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.5466,12.5488 L13.3276,12.5488 L13.3276,10.3298 C13.3276,9.9218 12.9966,9.5908 12.5886,9.5908 C12.1806,9.5908 11.8486,9.9218 11.8486,10.3298 L11.8486,12.5488 L9.6306,12.5488 C9.2216,12.5488 8.8906,12.8798 8.8906,13.2878 C8.8906,13.6968 9.2216,14.0278 9.6306,14.0278 L11.8486,14.0278 L11.8486,16.2468 C11.8486,16.6548 12.1806,16.9858 12.5886,16.9858 C12.9966,16.9858 13.3276,16.6548 13.3276,16.2468 L13.3276,14.0278 L15.5466,14.0278 C15.9546,14.0278 16.2856,13.6968 16.2856,13.2878 C16.2856,12.8798 15.9546,12.5488 15.5466,12.5488",
    id: "Fill-4",
    fill: "#F5426E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalBag);
export default __webpack_public_path__ + "static/media/medical_bag.acabe55382645c0106655390f7a7d610.svg";
export { ForwardRef as ReactComponent };